import { useQuery } from '@tanstack/react-query';
import { post } from 'app/shared/utils/fetchr';
import {
  PaginatedAgentsResponse,
  ShortAgentResponse,
} from 'app/modules/agents/responses';
import { AGENT_QUERY_KEYS } from 'app/modules/agents/queries/keys';
import DataLoader from 'dataloader';
import { DEFAULT_OFFSET } from 'app/shared/pagination/constants';

const dataLoader = new DataLoader<number, ShortAgentResponse>(
  async (ids) => {
    const response = await post<PaginatedAgentsResponse>(
      '/v1/agents/paginated',
      {
        offset: DEFAULT_OFFSET,
        limit: ids.length,
        ids,
      },
    );
    const agentMap = response.agents.reduce<Record<number, ShortAgentResponse>>(
      (acc, agent) => {
        acc[agent.id] = agent;
        return acc;
      },
      {},
    );
    return ids.map((id) => agentMap[id]);
  },
  {
    maxBatchSize: 100,
    // batch all requests happening within 100ms
    batchScheduleFn: (callback) => setTimeout(callback, 100),
    cache: false,
  },
);

export const useGetAgentShort = (id: number) => {
  return useQuery({
    queryKey: AGENT_QUERY_KEYS.getAgentShort(id),
    queryFn: () => dataLoader.load(id),
    staleTime: 60 * 60 * 1000, // 60 min
  });
};
